/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-syntax */
import ReactDOM from 'react-dom';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import OrcamentoMaterial from 'models/OrcamentoMaterial';

import {
  ChangeEvent,
  Fragment,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  FaCheck,
  FaCircle,
  FaEdit,
  FaEraser,
  FaExclamationTriangle,
  FaFileExcel,
  FaFilter,
  FaInfoCircle,
  FaPlus,
  FaPlusCircle,
  FaSearch,
  FaSync,
  FaTimes,
  FaTrash,
} from 'react-icons/fa';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  Alert,
} from 'reactstrap';
import api from 'services/api';
import {
  Checkbox,
  CircularProgress,
  Popper,
  TextField,
  Tooltip,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import exportToSheet from 'utils/exportToSheet';
import toast from 'react-hot-toast';
import Orcamento from 'models/Orcamento';
import TagModel from 'models/Tag';
import OrcamentoMaterialModel from 'models/EngenhariaMaterial';
import FloatingButton from 'components/FloatingButton';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import InputSelect from 'components/InputSelect';
import Produto from 'models/Produto';
import AutocompleteItemDomsge from 'components/AutocompleteItemDomsge';
import ItemDomsge from 'models/ItemDomsge';
import styled from 'styled-components';
import formatCurrency from 'utils/formatCurrency';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import { socket } from 'config/socket';
import { useAuth } from 'hooks/auth';
import Parametros from 'models/Parametros';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import { showCustomToast } from 'utils/CustomToast';
import Log from 'models/Log';
import {
  Column,
  Table as TableVirtualized,
  AutoSizer,
  CellMeasurerCache,
  CellMeasurer,
} from 'react-virtualized';
import traduzirNomeMaterial from 'utils/traduzirNomeMaterial';
import traduzirCodigoMaterial from 'utils/traduzirCodigoMaterial';
import ConfiguracaoDetalhesCabecalho from 'components/ConfiguracaoDetalhesCabecalho';
import { ImportarExcelReturn } from 'models/ImportarExcelReturn';
import Select, { SingleValue } from 'react-select';
import { Autocomplete } from '@material-ui/lab';
import ConfiguracaoMaterialAvulso from './components/MaterialAvulso';
import './style.css';
import ImportarExcel, { Opcoes } from '../Proposta/components/ImportarExcel';
import ModalFiltro from './components/ModalFiltro';
// Estilos
const ButtonsRightCol = styled(Col)`
  display: flex;
  justify-content: flex-center;
  align-items: center;
  margin-bottom: 1rem;
`;

const ColLabelItem = styled(Col)`
  display: flex;
  align-items: center;
`;

const LabelItem = styled(Label)`
  margin-bottom: 0;
  font-weight: 600;
`;

const MaterialListContainer = styled.div`
  margin-top: 1rem;
`;

const MaterialContainer = styled.div`
  margin-top: 1rem;
`;

const MaterialTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.875rem;
`;

const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  z-index: 10;
`;

const TableBody = styled.tbody``;

const GroupHeaderRow = styled.tr`
  background-color: #2f75b6;
  color: #fff;

  td {
    padding: 10px;
    font-weight: bold;
    font-size: 14px;
  }
`;

const ColumnHeaderRow = styled.tr`
  background-color: #2f75b6;
  color: #fff;

  th {
    padding: 10px;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
  }
`;

// const MaterialItemRow = styled.tr<{ isSubItem?: boolean }>`
//   background-color: ${props => (props.isSubItem ? '#f8f9fa' : '#ffffff')};

//   td {
//     padding: 8px 10px;
//     vertical-align: middle;
//     border-bottom: 1px solid #dee2e6;
//     ${props => props.isSubItem && 'font-style: italic;'}
//   }
// `;

// const SubItemRow = styled.tr`
//   background-color: #f8f9fa;
//   font-style: italic;

//   td {
//     padding: 5px 10px;
//     vertical-align: middle;
//     border-bottom: 1px solid #dee2e6;
//     font-size: 0.8rem;
//   }
// `;

// const KitSeparatorRow = styled.tr<{ isStart?: boolean }>`
//   td {
//     padding: 8px 10px;
//     vertical-align: middle;
//     text-align: center;
//     border-top: ${props =>
//       props.isStart ? '2px dotted #adb5bd' : '1px solid #dee2e6'};
//     border-bottom: ${props =>
//       !props.isStart ? '2px dotted #adb5bd' : '1px solid #dee2e6'};
//     font-weight: 600;
//     font-style: italic;
//     font-size: 0.875rem;
//     color: #495057;
//   }
// `;

const KitSeparatorRow = styled.tr<{ isStart?: boolean }>`
  td {
    padding: 8px 10px;
    vertical-align: middle;
    text-align: center;
    border-top: ${props =>
      props.isStart ? '2px dashed #C2c2c2 !important' : '1px solid #dee2e6'};
    border-bottom: ${props =>
      !props.isStart ? '2px dashed #C2c2c2 !important' : '1px solid #dee2e6'};
    border-left: 2px dashed #c2c2c2 !important;
    border-right: 2px dashed #c2c2c2 !important;
    font-weight: 600;
    font-style: italic;
    font-size: 0.875rem;
    color: #495057;
    background-color: #ffffff;
  }
`;

const MaterialItemRow = styled.tr<{ isSubItem?: boolean; inKitBox?: boolean }>`
  background-color: ${props => (props.isSubItem ? '#f8f9fa' : '#ffffff')};

  td {
    padding: 8px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    ${props => props.isSubItem && 'font-style: italic;'}
  }

  /* Draws the left and right walls of the box */
  ${props =>
    props.inKitBox &&
    `
    td:first-child { border-left: 2px dashed #C2c2c2 !important; }
    td:last-child { border-right: 2px dashed #C2c2c2 !important; }
  `}
`;

const SubItemRow = styled.tr<{ inKitBox?: boolean }>`
  background-color: #f8f9fa;
  font-style: italic;

  td {
    padding: 5px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    font-size: 0.8rem;
  }

  /* Draws the left and right walls of the box */
  ${props =>
    props.inKitBox &&
    `
    td:first-child { border-left: 2px dashed #C2c2c2 !important; }
    td:last-child { border-right: 2px dashed #C2c2c2 !important; }
  `}
`;

interface LocationState {
  orcamentoId: number;
  acessoLimitado: {
    acessoLimitado: boolean;
    temAcesso: boolean;
  };
}

interface MaterialComposicaoSalvar {
  id: number | null;
  quantidade: number;
  quantidadeCalculada: number;
  quantidadeOriginal: number;
  atividade: number;
  sequenciaAtividade: number;
  posicaoEsquematica: string;
  fabrEmprCodigo: string;
  fabrCodigo: string;
  diteDgpeCodigo: string;
  diteCodigo: string;
  descricao: string;
  tipoItem: 'PR' | 'MP' | 'KI';
  indicaKit: 'S' | 'N';
  criadoManualmente: boolean | 'N';
  cicloVidaStatus: null | any;
  cicloVidaSubstituto: null | any;
  blocoFkCAD: null | any;
  aplicacao: string;
  nivel: number;
  agrupador: string;
  composicao: OrcamentoMaterialModel[];
  quantidadeProjetada: number;
  ordem: null | any;
  liberado: boolean;
  dadosEngenharia: null | any;
  ordemAgrupador: string | '';
  excluirMaterial: boolean;
  selecionado: boolean;
  quantidadeEditavel: number;
  disabled?: boolean;
}

type UserNotification = {
  userId: number;
  hasUnread: boolean;
  changes: any[];
};

const ConfiguracaoMateriais: React.FC = () => {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const orcamentoId = location.state?.orcamentoId;
  const acessoLimitado = location.state?.acessoLimitado;
  const { usuario } = useAuth();

  const [orcamentoMateriais, setOrcamentoMateriais] = useState<
    OrcamentoMaterial[]
  >([]);
  const [filtroOrcamentoMateriais, setFiltroOrcamentoMateriais] = useState<
    OrcamentoMaterial[]
  >([]);
  const [orcamentoKits, setOrcamentoKits] = useState<OrcamentoMaterialModel[]>(
    [],
  );
  const [possuiMateriaisIndpie, setPossuiMateriaisIndpie] = useState(false);
  const [deletingMaterial, setDeletingMaterial] = useState(false);
  // const [exibeBadge, setExibeBadge] = useState(false);

  // Parece não estar sendo usado
  // const [orcamentos, setOrcamentos] = useState<Orcamento>({} as Orcamento);
  const [listaTodosMateriais, setListaTodosMateriais] = useState<any[]>([]);
  const [tags, settags] = useState<TagModel[]>([]);
  const [exibeKit, setExibeKit] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [materiaisAvulsosPlanilha, setMateriaisAvulsosPlanilha] = useState<
    OrcamentoMaterial[]
  >([]);
  const [itemDomsgeSelecionado, setItemDomsgeSelecionado] = useState<
    any | null
  >(null);
  const [quantidadeNovoItem, setQuantidadeNovoItem] = useState(1);
  const [produtos, setProdutos] = useState<Produto[]>([]);
  const [codEmpresa, setCodEmpresa] = useState('');

  const [kitCarregado, setKitCarregado] = useState(false);
  const [matCarregado, setMatCarregado] = useState(false);
  const [kitSelecionado, setKitSelecionado] = useState<any>(null);
  const [itensComposicao, setItensComposicao] = useState<
    MaterialComposicaoSalvar[]
  >([]);
  const [modalAdicionarItens, setModalAdicionarItens] = useState(false);

  // const [sequencia, setSequencia] = useState<number>();
  const [modalFiltros, setModalFiltros] = useState(false);
  const [limparFiltros, setLimparFiltros] = useState(false);
  const [qntFiltrosUsados, setQntFiltrosUsados] = useState<string[]>([]);

  const [agrupadorSelecionado, setAgrupadorSelecionado] = useState('Grupo');

  const [tiposExclusao, setTiposExclusao] = useState([]);
  const [deveRecarregarComp, setDeveRecarregarComp] = useState(true);
  const [usuariosOnline, setUsuariosOnline] = useState<
    { id: number; nome: string }[]
  >([]);

  const [showHidden, setShowHidden] = useState(false);
  const hiddenRef = useRef<HTMLDivElement>(null);
  const [parametros, setParametros] = useState<Parametros>();

  const [userNotifications, setUserNotifications] = useState<
    Record<number, UserNotification>
  >({});

  const [selectedUser, setSelectedUser] = useState<{
    id: number;
    nome: string;
  }>();
  const [modalOpen, setModalOpen] = useState(false);

  const [acessoLimitadoCusto, setAcessoLimitadoCusto] = useState(
    {} as ValidarAcessoPrograma,
  );
  const [gnf, setGnf] = useState(null);

  const [editingSequencia, setEditingSequencia] = useState<{
    atividade: number;
    sequencia: number;
  } | null>(null);
  const [tempTituloSequencia, setTempTituloSequencia] = useState('');
  const [logsUsuario, setLogsUsuario] = useState<Log[]>([]);

  const [hasDadosFiltro, setHasDadosFiltro] = useState(false);
  const [editandoId, setEditandoId] = useState<number | null | undefined>(null);
  const [quantidadeEditada, setQuantidadeEditada] = useState<number | null>(
    null,
  );
  const [loadingUpdateQnt, setLoadingUpdateQnt] = useState(false);

  const [quantidadesEditandoGrupo, setQuantidadesEditandoGrupo] = useState<{
    [key: string]: number;
  }>({});
  const [editandoGrupo, setEditandoGrupo] = useState(false);
  const [loadingUpdateGrupo, setLoadingUpdateGrupo] = useState(false);
  const [loadingIndpie, setLoadingIndpie] = useState(false);
  const [mostrarModalIndpie, setMostrarModalIndpie] = useState(false);
  const [arrayCodSap, setArrayCodSap] = useState<ImportarExcelReturn[]>([]);
  const [versaoIndpie, setVersaoIndpie] = useState<null | number>(null);
  const [versaoIndpieInicial, setVersaoIndpieInicial] = useState<null | number>(
    null,
  );

  const [versoesIndpieDisponiveis, setVersoesIndpieDisponiveis] = useState<
    number[]
  >([]);

  const [quantidadeMatSemErros, setQuantidadeMatSemErros] = useState<
    number | null
  >(null);
  const [quantidadeMatComErros, setQuantidadeMatComErros] = useState<
    number | null
  >(null);
  const [sessaoTempExcel, setSessaoTempExcel] = useState('');

  const selectedValue = versaoIndpie ?? versaoIndpieInicial;

  const atividadesComGap = useMemo(() => {
    const grouped = orcamentoMateriais.reduce((acc, item) => {
      const atividade = item.produtoAtividadeId || 0;
      if (!acc[atividade]) {
        acc[atividade] = [];
      }
      acc[atividade].push(item.sequenciaAtividade || 0);
      return acc;
    }, {} as Record<number, number[]>);

    const invalid = new Set<number>();
    Object.entries(grouped).forEach(([atividade, sequencias]) => {
      const uniqueSeqs = Array.from(new Set(sequencias))
        .filter(s => !Number.isNaN(s) && s > 0)
        .sort((a, b) => a - b);
      let valida = true;
      if (uniqueSeqs.length > 0) {
        if (uniqueSeqs[0] !== 1) {
          valida = false;
        } else {
          for (let i = 0; i < uniqueSeqs.length; i += 1) {
            if (uniqueSeqs[i] !== i + 1) {
              valida = false;
              break;
            }
          }
        }
      }
      if (!valida) {
        invalid.add(Number(atividade));
      }
    });
    return invalid;
  }, [orcamentoMateriais]);

  const cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 70,
  });

  useEffect(() => {
    const handleConfigUpdated = (data: any) => {
      const { materiaisModificados, tipo, user, isIndpie } = data;

      // Atualizações normais do estado (mantém como já está)
      if (tipo === 'excluir') {
        const idsExcluidos = new Set(
          materiaisModificados.map((m: any) => m.id),
        );

        setOrcamentoMateriais(prev =>
          prev.filter(material => !idsExcluidos.has(material.id)),
        );

        // showCustomToast({
        //   message: `${user.nome} excluiu ${materiaisModificados.length} item(s)`,
        //   type: 'error',
        // });
      } else if (tipo === 'criar') {
        const novosMateriais: OrcamentoMaterialModel[] =
          materiaisModificados.map((item: any) => ({
            ...item,
            atividadeSeq: item.sequenciaAtividade,
            criadoManualmente: true,
            orcamentoMaterialId: item.id,
            material: {
              ...item.material,
              codigoSap: item?.material?.codigoSap ?? item.codigo_sap,
              diteCodigo: item?.material?.diteCodigo ?? null,
            },
            produtoAtividade: {
              codSAP: item?.produtoAtividade?.codSAP ?? item.cod_sap,
              codSGE: item?.produtoAtividade?.codSGE ?? item.cod_sge,
            },
            isIndpie: isIndpie ?? false,
            materialImportado: item.material_importado,
          }));

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setOrcamentoMateriais(prev => [
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ...(isIndpie ? prev.filter(item => !item.isIndpie) : prev),
          ...novosMateriais,
        ]);
        setOrcamentoKits(prev => [
          ...(isIndpie ? prev.filter(item => !item.isIndpie) : prev),
          ...novosMateriais,
        ]);
      }

      // Se eu modifiquei, não mostra notificação para mim, somente para os outros
      if (user.id !== usuario.id) {
        setUserNotifications(prev => ({
          ...prev,
          [user.id]: {
            userId: user.id,
            hasUnread: true,
            changes: [
              ...(prev[user.id]?.changes || []),
              { tipo, materiaisModificados, date: new Date() },
            ],
          },
        }));
      }
    };

    const joinRoom = () => {
      socket.emit('join_config', {
        configId: orcamentoId,
        user: {
          id: usuario.id,
          nome: usuario.nome,
        },
      });
    };

    if (socket.connected) {
      joinRoom();
    }

    // socket.emit('join_config', {
    //   configId: orcamentoId,
    //   user: {
    //     id: usuario.id,
    //     nome: usuario.nome,
    //   },
    // });

    socket.on('connect', joinRoom);

    socket.on('config_updated', handleConfigUpdated);

    return () => {
      socket.emit('leave_config', orcamentoId);
      socket.off('connect', joinRoom);
      socket.off('config_updated');
    };
  }, [orcamentoMateriais, orcamentoKits]);

  useEffect(() => {
    socket.on('users_in_config', users => {
      setUsuariosOnline(users);
    });

    return () => {
      socket.off('users_in_config');
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        hiddenRef.current &&
        !hiddenRef.current.contains(event.target as Node)
      ) {
        setShowHidden(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleStartEditSequencia = (
    atividade: number,
    sequencia: number,
    currentTitle: string,
  ) => {
    setEditingSequencia({ atividade, sequencia });
    setTempTituloSequencia(currentTitle);
  };

  async function carregarParametros() {
    const response = await api.get('/parametros');
    if (response.data) setParametros(response.data as Parametros);
  }

  // const handleSaveSequenciaTitle = async () => {
  //   if (editingSequencia) {
  //     try {
  //       const response = await api.get(`/orcamento/material-titulo-sequencia`, {
  //         params: { ids, tempTituloSequencia },
  //       });

  //       setOrcamentoMateriais(prevMateriais =>
  //         prevMateriais.map(item => {
  //           if (
  //             item.produtoAtividadeId === editingSequencia.atividade &&
  //             item.sequenciaAtividade === editingSequencia.sequencia
  //           ) {
  //             return {
  //               ...item,
  //               tituloSequencia: tempTituloSequencia,
  //             };
  //           }
  //           return item;
  //         }),
  //       );
  //       setEditingSequencia(null);
  //       setTempTituloSequencia('');
  //     } catch (error) {
  //       setEditingSequencia(null);
  //       setTempTituloSequencia('');
  //       console.error('Erro ao salvar o título da sequência:', error);
  //       throw error;
  //     }
  //   }
  // };

  const handleSaveSequenciaTitle = async () => {
    if (editingSequencia) {
      Swal.fire({
        icon: 'info',
        text: `Atualizando título da sequência...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      try {
        const ids = orcamentoMateriais
          .filter(
            item =>
              item.produtoAtividadeId === editingSequencia.atividade &&
              item.sequenciaAtividade === editingSequencia.sequencia,
          )
          .map(item => item.id);

        const response = await api.post(
          `/orcamento/material-titulo-sequencia`,
          {
            ids,
            tituloSequencia: tempTituloSequencia,
          },
        );

        setOrcamentoMateriais(prevMateriais =>
          prevMateriais.map(item => {
            if (
              item.produtoAtividadeId === editingSequencia.atividade &&
              item.sequenciaAtividade === editingSequencia.sequencia
            ) {
              return {
                ...item,
                tituloSequencia: tempTituloSequencia,
              };
            }
            return item;
          }),
        );

        setEditingSequencia(null);
        setTempTituloSequencia('');

        toast.success('Título da sequência atualizado com sucesso!');
      } catch (error) {
        console.error('Erro ao salvar o título da sequência:', error);
        toast.error('Erro ao salvar o título da sequência');
      }
    }
    Swal.close();
  };

  const handleCancelEditSequencia = () => {
    setEditingSequencia(null);
    setTempTituloSequencia('');
  };

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 127,
      },
    });
    setAcessoLimitadoCusto(response.data);
  }

  async function returnMateriais(): Promise<any[]> {
    const response = await api.get(`/orcamento/${orcamentoId}/material-avulso`);
    return response.data;
  }

  async function carregaOrcamentoMateriais(): Promise<OrcamentoMaterial[]> {
    const response = await api.get(`/orcamento/lista-materiais-novo`, {
      params: { orcamentoId },
    });

    const materiaisAvulsos = await returnMateriais();

    const todosMateriais = [
      ...response.data.filter(
        (item: OrcamentoMaterial) => item.criadoManualmente === false,
      ),
      ...materiaisAvulsos.map(avulso => ({
        ...avulso,
        criadoManualmente: true,
      })),
    ];

    setOrcamentoMateriais(todosMateriais);
    setMatCarregado(true);

    Swal.close();
    return todosMateriais;
  }

  async function carregaOrcamento() {
    const orcamentoData = await api.get(`/orcamento/versao/${orcamentoId}`);
    const { codigoOportunidadeDomsge } = orcamentoData.data.orcamento;
    setGnf(codigoOportunidadeDomsge);
  }

  async function carregaProdutos() {
    const response = await api.get(`/produto/configuracao/${orcamentoId}`);
    setProdutos(response.data);
    setCodEmpresa(response.data[0]?.codigoEmpresa);
  }

  function comparar(
    a: OrcamentoMaterialModel,
    b: OrcamentoMaterialModel,
  ): number {
    if (a.ordemAgrupador < b.ordemAgrupador) return -1;
    if (a.ordemAgrupador > b.ordemAgrupador) return 1;
    if (a.agrupador < b.agrupador) return -1;
    if (a.agrupador > b.agrupador) return 1;
    if (a.posicaoEsquematica && b.posicaoEsquematica) {
      const posicaoA = a.posicaoEsquematica;
      const posicaoB = b.posicaoEsquematica;
      if (Number(posicaoA) < Number(posicaoB)) return -1;
      if (Number(posicaoA) > Number(posicaoB)) return 1;
    }
    if (a.atividade < b.atividade) return -1;
    if (a.atividade > b.atividade) return 1;
    if (a.sequenciaAtividade < b.sequenciaAtividade) return -1;
    if (a.sequenciaAtividade > b.sequenciaAtividade) return 1;
    return 0;
  }

  function obterInfoSeq(str: string): any {
    if (str) {
      const partes: string[] = str.split('-');
      const pos: number = partes[1]?.indexOf('.');
      const posEsq: string = partes[1]?.substring(pos + 1);
      let grupo: string = partes[1]?.substring(0, pos);
      if (grupo?.length === 1) {
        grupo = `0${grupo}`;
      }
      return { grupo, posEsq };
    }

    return { grupo: 99, posEsq: 0 };
  }

  async function addItemComposicao() {
    if (!itemDomsgeSelecionado) {
      toast.error('Selecione um item material para inserir');
      return;
    }

    const materialEncontrado = listaTodosMateriais.find(
      material =>
        material.codigoSap === itemDomsgeSelecionado.codigo ||
        material.diteCodigo === itemDomsgeSelecionado.codigo,
    );

    if (!materialEncontrado) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: `Não foi possível adicionar este material, pois ele não existe no POC.`,
      });
      return;
    }

    setItensComposicao(prev => [
      ...prev,
      {
        id: materialEncontrado.id,
        diteCodigo: materialEncontrado.diteCodigo,
        descricao: materialEncontrado.descricao,
        quantidade: quantidadeNovoItem,
        quantidadeCalculada: quantidadeNovoItem,
        quantidadeOriginal: quantidadeNovoItem,
        atividade: 0,
        sequenciaAtividade: 0,
        posicaoEsquematica: '',
        fabrEmprCodigo: '',
        fabrCodigo: '',
        diteDgpeCodigo: '',
        tipoItem: 'MP',
        indicaKit: 'N',
        criadoManualmente: true,
        cicloVidaStatus: null,
        cicloVidaSubstituto: null,
        blocoFkCAD: null,
        aplicacao: 'AVULSO',
        nivel: 0,
        agrupador: '',
        composicao: [],
        quantidadeProjetada: 0,
        ordem: null,
        liberado: false,
        dadosEngenharia: null,
        ordemAgrupador: '',
        excluirMaterial: false,
        selecionado: true,
        quantidadeEditavel: quantidadeNovoItem,
        disabled: false,
        codigoSAP: materialEncontrado.codigoSAP,
      },
    ]);

    setItemDomsgeSelecionado(null);
    setQuantidadeNovoItem(1);
    setResetKey(prev => prev + 1);

    socket.emit('update_config', {
      configId: orcamentoId,
      materiaisModificados: [materialEncontrado],
      tipo: 'criar',
      mensagem: `${usuario.nome} adicionou 1 material avulso.`,
      user: {
        id: usuario.id,
        nome: usuario.nome,
      },
    });
  }

  async function carregaOrcamentoKits(
    mostrarKit = false,
  ): Promise<OrcamentoMaterialModel[]> {
    // remover o integração no SAP
    const response = await api.get(
      `/material/material-composicao?configuracaoId=${orcamentoId}&carregarKit=${mostrarKit}`,
    );

    // if (response.data) setOrcamentos(response.data as Orcamento);

    const listaItensort: OrcamentoMaterialModel[] = response?.data;

    for (let index = 0; index < listaItensort.length; index += 1) {
      if (!listaItensort[index].posicaoEsquematica) {
        const grupo = obterInfoSeq(listaItensort[index].aplicacao);
        listaItensort[index].agrupador = grupo.grupo;
        listaItensort[index].posicaoEsquematica = grupo.posEsq;
      }
    }

    if (listaItensort && listaItensort.length) {
      setOrcamentoKits(listaItensort.sort(comparar));
      const temIndpie = listaItensort.some(item => item.isIndpie);
      setPossuiMateriaisIndpie(temIndpie);
    }
    setKitCarregado(true);
    Swal.close();
    return response.data;
  }

  async function carregaListaMateriais() {
    const response = await api.get(`/material/listAll`);
    setListaTodosMateriais(response.data);
  }

  async function listaTags() {
    const response = await api.get('/tag');
    settags(response.data);
  }

  async function getTiposExclusao() {
    const response = await api.get(`/tipo-exclusao/tipos`);
    setTiposExclusao(response.data);
  }

  // const recarregarLista = async () => {
  //   //setKitCarregado(false);
  //   // setMatCarregado(false);
  //   // carregaOrcamento();
  //   //carregaOrcamentoKits();
  //   // carregaOrcamentoMateriais();
  // };

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaTags();
    getAcessoLimitadoPrograma();
    carregaOrcamento();
    carregarParametros();
  }, []);

  useEffect(() => {
    if (deveRecarregarComp) {
      carregaOrcamentoKits();
      carregaOrcamentoMateriais();
      setDeveRecarregarComp(false);
    }
  }, [deveRecarregarComp]);

  useEffect(() => {
    if (!kitCarregado || !matCarregado || !deveRecarregarComp) {
      Swal.fire({
        icon: 'info',
        text: `Buscando materiais...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    }
  }, [kitCarregado, matCarregado, deveRecarregarComp]);

  useEffect(() => {
    if (kitCarregado && matCarregado && deveRecarregarComp) {
      Swal.close();
    }
  }, [kitCarregado, matCarregado, deveRecarregarComp]);

  useEffect(() => {
    // carregaOrcamento();
    carregaProdutos();
    carregaListaMateriais();
  }, []);

  useEffect(() => {
    if (deletingMaterial) {
      toast.loading(`Excluindo item da configuração ${orcamentoId}...`, {
        position: 'top-right',
      });
      return;
    }

    toast.dismiss();
  }, [deletingMaterial]);

  async function pegarDadosOrcamento() {
    const orcamento = await api.get(`/orcamento/versao/${orcamentoId}`);
    const {
      codigoOportunidadeDomsge: gnf2,
      versaoIndpie: versaoIndpieCadastrada,
    } = orcamento.data.orcamento;
    setVersaoIndpieInicial(versaoIndpieCadastrada);
    setVersaoIndpie(versaoIndpieCadastrada);
    // setCodigoOportunidadeDomsge(gnf2);
  }

  useEffect(() => {
    getTiposExclusao();
    pegarDadosOrcamento();
  }, []);

  const openUserModal = async (user: any) => {
    setSelectedUser(user);

    setUserNotifications(prev => ({
      ...prev,
      [user.id]: {
        ...prev[user.id],
        hasUnread: false,
      },
    }));

    const response = await api.get('/log/configuracao', {
      params: {
        nomeChave: 'orcamento_id',
        valorChave: `${orcamentoId}`,
        usuarioId: user.id,
      },
    });

    setLogsUsuario(response.data);

    setModalOpen(true);
  };

  async function handleAdicionarItensKit() {
    const materialSelecionado = orcamentoMateriais.find(
      item => item.excluirMaterial === true,
    );
    if (materialSelecionado) {
      const materialComposicao = orcamentoKits.find(
        k => k.orcamentoMaterialId === materialSelecionado.id,
      )?.composicao;
      if (materialComposicao && materialComposicao.length > 0) {
        setKitSelecionado(materialSelecionado);

        const materialComposicaoSalvar = materialComposicao.map(item => ({
          ...item,
          quantidade: item.quantidade * materialSelecionado.quantidade,
          selecionado: item.id !== null,
          // quantidadeEditavel: item.quantidadeCalculada,
          quantidadeEditavel: item.quantidade * materialSelecionado.quantidade,
          disabled: item.id === null,
        }));

        setItensComposicao(materialComposicaoSalvar);
        setModalAdicionarItens(true);
      }
    }
  }

  const handleQuantidadeChange = (itemIndex: number, newValue: number) => {
    setItensComposicao(prev =>
      prev.map((item, index) =>
        index === itemIndex ? { ...item, quantidadeEditavel: newValue } : item,
      ),
    );
  };

  const handleSelectionChange = (itemIndex: number, selecionado: boolean) => {
    setItensComposicao(prev =>
      prev.map((item, index) =>
        index === itemIndex ? { ...item, selecionado } : item,
      ),
    );
  };

  const buscaCodigoMaterial = (materialId: number | null) => {
    if (!materialId) return '';
    const material = listaTodosMateriais.find(
      m => Number(m.id) === Number(materialId),
    );
    return material?.codigoSap || material?.diteCodigo || '';
  };

  const buscaCodigoMaterialParametro = (materialId: any) => {
    if (!materialId) return '';
    const material = listaTodosMateriais.find(
      m => Number(m.id) === Number(materialId),
    );
    console.log('parametros: ', parametros);
    if (parametros?.indicMateriaisSAP) {
      return material?.codigoSap || '';
    }
    return material?.diteCodigo || '';
  };

  async function handleAdicionarItensConfirmar() {
    try {
      Swal.fire({
        title: 'Salvando itens do kit...',
        icon: 'info',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const itensAdicionar = itensComposicao.filter(
        item => item.selecionado === true,
      );

      const response = await api.post('/orcamento/versao/adicionar-itens-kit', {
        materialDelete: kitSelecionado,
        materiaisInsert: itensAdicionar,
        orcamentoParteId: kitSelecionado?.orcamentoParteId,
        orcamentoId,
      });

      const response2 = await api.post(
        '/orcamento/verifica-material-titulo-sequencia',
        {
          orcamentoId,
        },
      );

      Swal.fire({
        title:
          'Itens do kit salvos com sucesso! Atualizando lista de materiais. Por favor, aguarde...',
        icon: 'success',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      setModalAdicionarItens(false);

      // await carregaOrcamentoKits(true);
      await carregaOrcamentoMateriais();
      await carregaOrcamentoKits(exibeKit);
    } catch (error) {
      toast.error('Erro ao adicionar itens do kit');
      console.error(error);
    }
  }

  async function handleDeletePropostaConfiguracaoMaterial() {
    const idsArray: number[] = [];

    let textoDescricao = '';
    const OrcamentoMateriais = orcamentoMateriais
      .filter(items => items.excluirMaterial === true)
      .map(materialItem_ => materialItem_) as OrcamentoMaterial[];

    for await (const item of OrcamentoMateriais) {
      textoDescricao = `${textoDescricao} + ${traduzirNomeMaterial(
        item.material,
      )} <br />`;
      idsArray.push(Number(item.id));
    }

    async function deletePropostaConfiguracaoMaterial(
      tipoExclusaoId: string,
      motivo: string,
    ) {
      try {
        setDeletingMaterial(true);

        await api.post('tipo-exclusao/salvar-excluir-materiais', {
          materiais: OrcamentoMateriais,
          tipoExclusao: tipoExclusaoId,
          orcamentoId,
          motivo,
        });

        socket.emit('update_config', {
          configId: orcamentoId,
          materiaisModificados: OrcamentoMateriais,
          tipo: 'excluir',
          mensagem: `${usuario.nome} excluiu ${OrcamentoMateriais.length} item(s)`,
          user: {
            id: usuario.id,
            nome: usuario.nome,
          },
        });

        // socket.emit('update_config', {
        //   configId: orcamentoId,
        //   materiaisModificados: OrcamentoMateriais,
        //   tipo: 'excluir',
        // });
        setDeletingMaterial(false);
        carregaOrcamentoMateriais();
        // carregaOrcamento();
      } finally {
        setDeletingMaterial(false);
      }
    }

    async function openModal() {
      const wrapper = document.createElement('div');

      Swal.fire({
        title: `Excluir item da configuração ${orcamentoId}?`,
        html: wrapper,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, excluir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
        preConfirm: () => {
          const motivoInput = document.querySelector(
            '#motivo-input',
          ) as HTMLInputElement;
          const selectedTipo = document.querySelector(
            '#tipos_exclusao',
          ) as HTMLSelectElement;

          const motivo = motivoInput?.value;
          const tipo = selectedTipo?.value;

          if (!tipo || tipo.trim() === '') {
            Swal.showValidationMessage('Selecione um tipo de exclusão válido.');
            return false;
          }

          return { motivo, tipo };
        },
      }).then(result => {
        if (result.isConfirmed && result.value) {
          const { motivo, tipo } = result.value;
          deletePropostaConfiguracaoMaterial(tipo, motivo);
        }
      });

      const selectOptions = tiposExclusao
        .filter((tipo: any) => tipo.indicTipoExclusao)
        .map((tipo: any) => ({
          value: tipo.id,
          name: tipo.descricao,
        }));

      ReactDOM.render(
        <div>
          <strong>Selecione o motivo da exclusão*:</strong>
          <InputSelect id="tipos_exclusao" options={selectOptions} />
          <br />
          <strong>Complemento da exclusão do material:</strong>
          <input
            id="motivo-input"
            className="swal2-input"
            placeholder="Complemento da exclusão"
          />
        </div>,
        wrapper,
      );
    }

    openModal();
  }

  function handleSetRegraItemValue(
    materialItem: OrcamentoMaterial,
    attrName: string,
    value: string | number | boolean | null,
  ) {
    setOrcamentoMateriais(
      orcamentoMateriais.map(materialItem_ =>
        materialItem_.id === materialItem.id
          ? { ...materialItem_, [attrName]: value, regraAlterada: true }
          : materialItem_,
      ),
    );
  }

  function handleChangeAtivo(
    materialItem: OrcamentoMaterial,
    event: ChangeEvent<HTMLInputElement>,
  ) {
    const { checked } = event.target;
    const value = !!checked;
    handleSetRegraItemValue(materialItem, 'excluirMaterial', value);
  }

  function retornaOrigem(orcamentoMaterial: OrcamentoMaterial) {
    const { criadoManualmente, importacaoMaterialId, importacaoMaterial } =
      orcamentoMaterial;

    const mostrarImportado =
      criadoManualmente !== undefined &&
      criadoManualmente === true &&
      importacaoMaterialId !== null;

    const mostrarCriadoManualmente =
      criadoManualmente !== undefined && criadoManualmente === true;

    if (mostrarImportado) {
      return 'I';
    }

    if (mostrarCriadoManualmente) {
      return 'M';
    }

    return 'A';
  }

  function handleSelecionarItem(itemDomsge: iAutoCompleteItem | null) {
    setItemDomsgeSelecionado(itemDomsge);
  }

  async function handleSalvarQuantidade(
    id: number | undefined,
    novaQuantidade: number | null,
  ) {
    if (novaQuantidade === null || novaQuantidade < 0) return;

    try {
      toast.loading('Atualizando quantidade');
      setLoadingUpdateQnt(true);

      await api.put(`/orcamento/orcamento-material/atualizar`, {
        id,
        qnt: novaQuantidade,
      });
    } catch (error) {
      console.log(error);
    } finally {
      await carregaOrcamentoMateriais();
      setDeveRecarregarComp(true);
      setLoadingUpdateQnt(false);
      setEditandoId(null);
      toast.success('Quantidade atualizada');
      toast.dismiss();
    }
  }

  function handleExportToSheet() {
    const todosMateriais = [...materiaisAvulsosPlanilha, ...orcamentoMateriais];

    const dadosPlanilha = todosMateriais
      .filter(x => x.orcamentoMaterialId === null)
      .map(orcamentoMaterial => {
        const { material, regraAplicacao, quantidade } = orcamentoMaterial;
        const { diteCodigo, descricao } = material;
        return {
          Código: diteCodigo,
          Descrição: descricao,
          Aplicação: regraAplicacao,
          Quantidade: quantidade,
          Origem: retornaOrigem(orcamentoMaterial),
        };
      });
    const nomeArquivo = `Materiais - Configuração ${orcamentoId}`;
    exportToSheet(dadosPlanilha, nomeArquivo);
  }

  function retornaFiltradoOuTudo() {
    return filtroOrcamentoMateriais.length > 0 || hasDadosFiltro
      ? filtroOrcamentoMateriais
      : orcamentoMateriais;
  }

  async function salvarGrupo(materiais: OrcamentoMaterial[]) {
    const materiaisAlterados = materiais
      .filter(mat => {
        const novaQnt = quantidadesEditandoGrupo[mat?.id ?? 0];
        return novaQnt !== undefined && novaQnt !== mat.quantidade;
      })
      .map(mat => ({
        id: mat.id,
        quantidade: quantidadesEditandoGrupo[mat?.id ?? 0],
      }));

    setOrcamentoMateriais(prev =>
      prev.map(mat => {
        const alterado = materiaisAlterados.find(a => a.id === mat.id);
        if (alterado) {
          return {
            ...mat,
            quantidade: alterado.quantidade,
            regraAlterada: true,
          };
        }
        return mat;
      }),
    );

    if (materiaisAlterados.length > 0) {
      toast.loading('Atualizando materiais');
      await api.put(`/orcamento/orcamento-material/atualizar-lista`, {
        lista: materiaisAlterados,
      });
      toast.dismiss();
      toast.success('Materiais atualizados');
    }

    setEditandoGrupo(false);
    setQuantidadesEditandoGrupo({});
  }

  const iniciarEdicaoGrupo = (
    titulo: string,
    materiais: OrcamentoMaterial[],
  ) => {
    setEditandoGrupo(true);

    const novoEstado: { [key: string]: number } = {};
    materiais.forEach(mat => {
      novoEstado[mat?.id ?? 0] = mat.quantidade;

      setQuantidadesEditandoGrupo(novoEstado);
    });
  };

  const renderQuantidade = (
    orcamentoMaterial: OrcamentoMaterial,
    grupoId: string,
  ) => {
    if (editandoGrupo) {
      return (
        <Input
          type="number"
          value={
            quantidadesEditandoGrupo[orcamentoMaterial?.id ?? 0] ??
            orcamentoMaterial.quantidade
          }
          style={{ width: '80px', textAlign: 'center' }}
          onChange={e => {
            const valor = Number(e.target.value);
            setQuantidadesEditandoGrupo(prev => ({
              ...prev,
              [orcamentoMaterial?.id ?? 0]: valor,
            }));
          }}
        />
      );
    }

    if (editandoId === orcamentoMaterial.id) {
      return (
        <Input
          type="number"
          value={quantidadeEditada ?? ''}
          style={{ width: '80px', textAlign: 'center' }}
          onChange={e => setQuantidadeEditada(Number(e.target.value))}
        />
      );
    }

    return arredondaDecimais(Number(orcamentoMaterial.quantidade), 3) ?? '';
  };

  function renderMateriais() {
    if (!orcamentoMateriais.length) {
      return <></>;
    }

    function renderLinhaMaterial(
      orcamentoMaterial: OrcamentoMaterial,
      index: number,
      isSubItem = false,
      inKitBox = false, // <-- ADD THIS
    ) {
      const orcamentoKit = orcamentoKits.find(
        item => item.orcamentoMaterialId === orcamentoMaterial?.id,
      );

      const isMaterialAvulso = orcamentoKit?.criadoManualmente;

      const isIndpie = orcamentoKit?.isIndpie;

      const ciclo = orcamentoKit?.cicloVidaStatus;

      const posicaoEsquematica = orcamentoKit?.posicaoEsquematica ?? 0;

      const atividade = orcamentoMaterial?.produtoAtividade
        ? traduzirProdutoAtividade(orcamentoMaterial.produtoAtividade, true)
        : '';

      const atividadeSeq = orcamentoKit?.sequenciaAtividade;

      const agrupador = orcamentoKit?.agrupador ?? 99;

      const tipoItem = orcamentoKit?.unidadeMedida;

      const materialImportado = orcamentoKit?.materialImportado;

      const nomeArquivo = orcamentoKit?.nomeArquivo;

      const custoTotal =
        orcamentoKit?.custoTotal !== null
          ? formatCurrency(arredondaDecimais(orcamentoKit?.custoTotal))
          : '';

      const custoUnitario =
        orcamentoKit?.custoUnitario !== null
          ? formatCurrency(arredondaDecimais(orcamentoKit?.custoUnitario))
          : '';

      return (
        <MaterialItemRow
          key={`${orcamentoMaterial.id}_${index}`}
          isSubItem={isSubItem}
          inKitBox={inKitBox}
        >
          <td className="text-center">{atividade ?? ''}</td>
          <td className="text-center">{atividadeSeq ?? ''}</td>
          <td className="text-center">{agrupador ?? ''}</td>
          <td className="text-center">{posicaoEsquematica ?? ''}</td>
          <td className="text-center">
            {traduzirCodigoMaterial(orcamentoMaterial?.material)}
          </td>
          <td
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}
          >
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {orcamentoMaterial.descricao ??
              orcamentoMaterial?.material.descricao}
            {isIndpie && (
              <span title="Material adicionado manualmente na configuração">
                <Badge color="info" className="ml-2">
                  INDPIE
                </Badge>
              </span>
            )}
            {isMaterialAvulso && !isIndpie && !materialImportado && (
              <span title="Material adicionado manualmente na configuração">
                <Badge color="success" className="ml-2">
                  M
                </Badge>
              </span>
            )}
            {materialImportado && !isIndpie && (
              <span title={nomeArquivo}>
                <Badge
                  style={{ backgroundColor: '#FFD700', color: '#000' }}
                  className="ml-2"
                >
                  I
                </Badge>
              </span>
            )}
          </td>
          <td className="text-center">
            {renderQuantidade(orcamentoMaterial, 'tst')}
          </td>
          <td className="text-center" hidden={!acessoLimitadoCusto.temAcesso}>
            {custoUnitario}
          </td>
          <td className="text-center" hidden={!acessoLimitadoCusto.temAcesso}>
            {custoTotal}
          </td>
          <td className="text-center">{tipoItem}</td>
          <td>{orcamentoMaterial.regraAplicacao}</td>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <td className="text-center">{orcamentoMaterial?.material?.peso}</td>
          <td className="text-center">{ciclo}</td>
          <td className="text-center">
            {buscaCodigoMaterialParametro(orcamentoMaterial.materialKitId)}
          </td>
          <td>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                height: '100%',
              }}
            >
              {editandoId === orcamentoMaterial.id ? (
                <>
                  <Button
                    size="sm"
                    color="success"
                    className="btn-icon"
                    disabled={loadingUpdateQnt}
                    onClick={() => {
                      handleSalvarQuantidade(
                        orcamentoMaterial.id,
                        quantidadeEditada,
                      );
                      // setEditandoId(null);
                    }}
                  >
                    <FaCheck />
                  </Button>

                  <Button
                    size="sm"
                    color="danger"
                    className="btn-icon"
                    disabled={loadingUpdateQnt}
                    onClick={() => {
                      setEditandoId(null);
                      setQuantidadeEditada(null);
                    }}
                  >
                    <FaTimes />
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    size="sm"
                    className="btn-icon"
                    hidden={
                      (!orcamentoMaterial.criadoManualmente &&
                        orcamentoMaterial.importacaoMaterialId === null &&
                        !orcamentoMaterial.isIndpie) ||
                      editandoGrupo
                    }
                    color="warning"
                    type="button"
                    onClick={() => {
                      setEditandoId(orcamentoMaterial.id);
                      setQuantidadeEditada(orcamentoMaterial.quantidade);
                    }}
                  >
                    <FaEdit />
                  </Button>

                  <Checkbox
                    checked={orcamentoMaterial.excluirMaterial}
                    onChange={(e: any) => {
                      handleChangeAtivo(orcamentoMaterial, e);
                    }}
                    color="primary"
                  />
                </>
              )}
            </div>
          </td>
        </MaterialItemRow>
      );
    }

    function renderComposicaoKit(
      materialPai: OrcamentoMaterial,
      inKitBox = false,
    ) {
      const composicao = orcamentoKits.find(
        item => item.orcamentoMaterialId === materialPai?.id,
      )?.composicao;

      if (!composicao || composicao.length === 0 || !exibeKit) return null;

      const quantidadePai = materialPai.quantidade;

      return composicao.map((item, index) => (
        <SubItemRow key={`comp_${index}`} inKitBox={inKitBox}>
          <td className="text-center">{item.atividade ?? ''}</td>
          <td className="text-center">{item.sequenciaAtividade ?? ''}</td>
          <td className="text-center">{item.agrupador ?? ''}</td>
          <td className="text-center">{item.posicaoEsquematica ?? ''}</td>
          <td className="text-center">{traduzirCodigoMaterial(item as any)}</td>
          <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {item.descricao}
          </td>
          <td className="text-center">
            {arredondaDecimais(item.quantidade * quantidadePai, 3)}
          </td>
          <td />
          <td className="text-center">{item.tipoItem}</td>
          <td>{item.aplicacao}</td>
          <td className="text-center">{item.cicloVidaStatus}</td>
          <td />
          <td />
        </SubItemRow>
      ));
    }

    function renderItemsKitGrouped(itemsToRender: OrcamentoMaterial[]) {
      const processedKitIds = new Set<number>();
      const result: JSX.Element[] = [];

      itemsToRender.forEach((item, index) => {
        const kitId = (item as any).kitOrigemOrcMatId;
        const kitPaiMatId = (item as any).materialKitId;
        const kitDesc = (item as any).kitOrigemDescricao;
        const kitQtd = (item as any).kitOrigemQuantidade;

        if (kitId) {
          if (!processedKitIds.has(kitId)) {
            processedKitIds.add(kitId);

            // Busca todos os itens explodidos do mesmo kit
            const kitItems = itemsToRender.filter(
              (i: any) => i.kitOrigemOrcMatId === kitId,
            );

            // 1. Linha Início
            result.push(
              <KitSeparatorRow key={`kit-start-${kitId}`} isStart>
                <td colSpan={15}>
                  {buscaCodigoMaterialParametro(kitPaiMatId)} - {kitDesc} - Qtd{' '}
                  {kitQtd}
                </td>
              </KitSeparatorRow>,
            );

            // 2. Itens do Kit
            kitItems.forEach((kitItem, kIndex) => {
              result.push(
                <Fragment key={kitItem.id}>
                  {renderLinhaMaterial(kitItem, index + kIndex, false, true)}
                  {renderComposicaoKit(kitItem, true)}
                </Fragment>,
              );
            });

            // 3. Linha fim
            result.push(
              <KitSeparatorRow key={`kit-end-${kitId}`}>
                <td colSpan={15}>
                  {buscaCodigoMaterialParametro(kitPaiMatId)} - {kitDesc} - FIM
                </td>
              </KitSeparatorRow>,
            );
          }
        } else {
          // Item normal (Avulso / No Kit)
          result.push(
            <Fragment key={item.id}>
              {renderLinhaMaterial(item, index)}
              {renderComposicaoKit(item)}
            </Fragment>,
          );
        }
      });

      return result;
    }

    function renderCabecalhoGrupo(titulo: string, tag: any, isAvulsos = false) {
      const materiaisUsar = isAvulsos
        ? orcamentoMateriais.filter(item => item.criadoManualmente === true)
        : orcamentoMateriais.filter((item2: any) =>
            tag?.agrupadorTag?.find(
              (items: { regraAgrupador: { nome: string } }) =>
                items.regraAgrupador.nome === item2.regraAplicacao,
            ),
          );

      const allChecked = !(
        materiaisUsar.filter(item => item.excluirMaterial === false).length > 0
      );

      return (
        <>
          <GroupHeaderRow>
            <th className="text-center">
              <span>{titulo}</span>
            </th>
            <th colSpan={acessoLimitadoCusto.temAcesso ? 14 : 13} />
          </GroupHeaderRow>
          <GroupHeaderRow>
            <th className="text-center">Ativ.</th>
            <th className="text-center">Seq.</th>
            <th className="text-center">Grupo</th>
            <th className="text-center">Ordem</th>
            <th className="text-center">Cod.</th>
            <th className="text-center">Descrição</th>
            <th className="text-center">Qtd.</th>
            <th className="text-center" hidden={!acessoLimitadoCusto.temAcesso}>
              Custo Un.
            </th>
            <th className="text-center" hidden={!acessoLimitadoCusto.temAcesso}>
              Custo Total
            </th>
            <th className="text-center">Un.</th>
            <th className="text-center">Aplicação</th>
            <th className="text-center">Peso</th>
            <th className="text-center">Status</th>
            <th className="text-center">Kit Origem</th>
            <th>
              <div className={`text-center ${isAvulsos ? 'float-right' : ''}`}>
                {editandoGrupo && titulo === 'AVULSOS' ? (
                  <>
                    <Button
                      size="sm"
                      color="success"
                      onClick={() => salvarGrupo(materiaisUsar)}
                    >
                      <FaCheck />
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => setEditandoGrupo(false)}
                    >
                      <FaTimes />
                    </Button>
                  </>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      size="sm"
                      hidden={titulo !== 'AVULSOS' || editandoId !== null}
                      color="warning"
                      onClick={() => iniciarEdicaoGrupo(titulo, materiaisUsar)}
                    >
                      <FaEdit />
                    </Button>
                    <Checkbox
                      checked={allChecked}
                      onChange={(e: any) => {
                        if (isAvulsos) {
                          setOrcamentoMateriais(prevMateriais =>
                            prevMateriais.map(material =>
                              material.criadoManualmente === true
                                ? {
                                    ...material,
                                    excluirMaterial: e.target.checked,
                                    regraAlterada: true,
                                  }
                                : material,
                            ),
                          );
                        } else {
                          const listaAlterar = orcamentoMateriais.filter(
                            (item2: any) =>
                              tag?.agrupadorTag?.find(
                                (items: { regraAgrupador: { nome: string } }) =>
                                  items.regraAgrupador.nome ===
                                  item2.regraAplicacao,
                              ),
                          );

                          setOrcamentoMateriais(prevMateriais =>
                            prevMateriais.map(material => {
                              const isInGroup = listaAlterar.some(
                                groupItem => groupItem.id === material.id,
                              );
                              return isInGroup
                                ? {
                                    ...material,
                                    excluirMaterial: e.target.checked,
                                    regraAlterada: true,
                                  }
                                : material;
                            }),
                          );
                        }
                      }}
                      color="primary"
                      title="Selecionar todos"
                    />
                  </div>
                )}
              </div>
            </th>
          </GroupHeaderRow>
        </>
      );
    }

    function renderTabelaPorGrupo() {
      if (hasDadosFiltro && filtroOrcamentoMateriais.length === 0) {
        return (
          <tbody>
            <tr>
              <td
                colSpan={5}
                style={{ textAlign: 'center', padding: '20px', color: '#555' }}
              >
                Nenhum registro encontrado para o filtro aplicado
              </td>
            </tr>
          </tbody>
        );
      }
      return (
        <>
          {retornaFiltradoOuTudo().filter(
            item => item.criadoManualmente === true,
          ).length > 0 && (
            <>
              <thead>
                {renderCabecalhoGrupo(
                  'AVULSOS',
                  {
                    id: null,
                    codigo: null,
                    descricao: 'Materiais Avulsos',
                    agrupadorTag: [{ regraAgrupador: {} }],
                  },
                  true,
                )}
              </thead>
              {/* <tbody>
                {orcamentoMateriais
                  .filter(item => item.criadoManualmente === true)
                  .map((item, index) => (
                    <Fragment key={item.id}>
                      {renderLinhaMaterial(item, index)}
                      {renderComposicaoKit(item)}
                    </Fragment>
                  ))}
              </tbody> */}
              <tbody>
                {renderItemsKitGrouped(
                  retornaFiltradoOuTudo().filter(
                    item => item.criadoManualmente === true,
                  ),
                )}
              </tbody>
            </>
          )}

          {tags
            .filter(item =>
              item?.agrupadorTag?.some(
                (items: { regraAgrupador: { nome: string } }) =>
                  retornaFiltradoOuTudo().find(
                    (item2: any) =>
                      item2.regraAplicacao === items.regraAgrupador.nome,
                  ),
              ),
            )
            ?.map(tag => {
              const textoDesc = `${String(tag?.codigo)}) ${String(
                tag?.descricao,
              )}`;

              return (
                <Fragment key={tag.id}>
                  {renderCabecalhoGrupo(textoDesc, tag)}

                  {renderItemsKitGrouped(
                    retornaFiltradoOuTudo().filter((item2: any) =>
                      tag?.agrupadorTag?.find(
                        items =>
                          items.regraAgrupador.nome === item2.regraAplicacao,
                      ),
                    ),
                  )}
                </Fragment>
              );
            })}
        </>
      );
    }

    function renderTabelaPorAtividade() {
      if (hasDadosFiltro && filtroOrcamentoMateriais.length === 0) {
        return (
          <tbody>
            <tr>
              <td
                colSpan={5}
                style={{ textAlign: 'center', padding: '20px', color: '#555' }}
              >
                Nenhum registro encontrado para o filtro aplicado
              </td>
            </tr>
          </tbody>
        );
      }

      const groupedByAtividade = retornaFiltradoOuTudo().reduce((acc, item) => {
        const atividade = item.produtoAtividadeId || 0;
        if (!acc[atividade]) {
          acc[atividade] = [];
        }
        acc[atividade].push(item);
        return acc;
      }, {} as Record<number, OrcamentoMaterial[]>);

      return (
        <>
          {Object.entries(groupedByAtividade).map(([atividade, items]) => {
            const allChecked = items.every(item => item.excluirMaterial);

            const ativUsar = items[0].produtoAtividade;

            const groupedBySequencia = items.reduce((acc, item) => {
              const sequencia = item?.sequenciaAtividade || 0;

              if (!acc[sequencia]) {
                acc[sequencia] = [];
              }
              acc[sequencia].push(item);
              return acc;
            }, {} as Record<number, OrcamentoMaterial[]>);

            const sortedSequencias = Object.keys(groupedBySequencia)
              .map(Number)
              .sort((a, b) => a - b);

            const temGap = atividadesComGap.has(Number(atividade));

            return (
              <Fragment key={atividade}>
                <thead>
                  <GroupHeaderRow>
                    <th className="text-center">
                      {ativUsar ? traduzirProdutoAtividade(ativUsar) : ''}
                      {temGap && (
                        <Badge
                          color="warning"
                          className="ml-2"
                          style={{ color: '#000', backgroundColor: '#ffc107' }}
                        >
                          <FaExclamationTriangle className="mr-1" /> Sequência
                          Inconsistente
                        </Badge>
                      )}
                    </th>
                    <th colSpan={acessoLimitadoCusto.temAcesso ? 14 : 13} />
                  </GroupHeaderRow>
                  <GroupHeaderRow>
                    <th className="text-center px-0 mx-0">Ativ</th>
                    <th className="text-center">Seq</th>
                    <th className="text-center">Grupo</th>
                    <th className="text-center">Ordem</th>
                    <th className="text-center">Cod.</th>
                    <th className="text-center">Descrição</th>
                    <th className="text-center">Qtd.</th>
                    <th
                      className="text-center"
                      hidden={!acessoLimitadoCusto.temAcesso}
                    >
                      Custo Un.
                    </th>
                    <th
                      className="text-center"
                      hidden={!acessoLimitadoCusto.temAcesso}
                    >
                      Custo Total
                    </th>
                    <th className="text-center">Un.</th>
                    <th className="text-center">Aplicação</th>
                    <th className="text-center">Peso</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Kit Origem</th>
                    <th>
                      <div className="text-center float-right">
                        <> </>
                        <Checkbox
                          checked={allChecked}
                          onChange={e => {
                            const { checked } = e.target;
                            setOrcamentoMateriais(prevMateriais =>
                              prevMateriais.map(material => {
                                if (
                                  items.some(item => item.id === material.id)
                                ) {
                                  return {
                                    ...material,
                                    excluirMaterial: checked,
                                    regraAlterada: true,
                                  };
                                }
                                return material;
                              }),
                            );
                          }}
                          color="primary"
                          title="Selecionar todos"
                        />
                      </div>
                    </th>
                  </GroupHeaderRow>
                </thead>

                <tbody>
                  {sortedSequencias.map(sequencia => {
                    const sequenciaItems = groupedBySequencia[sequencia];
                    const tituloSequencia =
                      sequenciaItems[0]?.tituloSequencia || '';

                    const quantidade = sequenciaItems.reduce(
                      (total, item) => total + item.quantidade,
                      0,
                    );

                    const custoTotalSomatorio = sequenciaItems.reduce(
                      (total, item) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        total + item.custoUnitario * item.quantidade,
                      0,
                    );

                    const custoUnitarioSomatorio = sequenciaItems.reduce(
                      (total, item) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        total + item.custoUnitario,
                      0,
                    );

                    const pesoTotal = sequenciaItems.reduce(
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      (total, item) => total + (item.material?.peso ?? 0),
                      0,
                    );

                    console.log({ sequenciaItems });

                    const isEditing =
                      editingSequencia?.atividade === Number(atividade) &&
                      editingSequencia?.sequencia === sequencia;

                    return (
                      <Fragment key={sequencia}>
                        {/* Sequencia separator row - acts as a line break */}
                        {sortedSequencias.length > 0 && (
                          <tr style={{ backgroundColor: '#f8f9fa' }}>
                            <td
                              colSpan={6}
                              style={{
                                padding: '8px 10px',
                                fontWeight: 'bold',
                                fontStyle: 'italic',
                                borderBottom: '2px solid #dee2e6',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                }}
                              >
                                <span>Sequência {sequencia}</span>

                                {isEditing ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                    }}
                                  >
                                    <Input
                                      type="text"
                                      value={tempTituloSequencia}
                                      onChange={e =>
                                        setTempTituloSequencia(e.target.value)
                                      }
                                      onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                          handleSaveSequenciaTitle();
                                        }
                                      }}
                                      style={{
                                        padding: '2px 6px',
                                        fontSize: '14px',
                                        height: '28px',
                                      }}
                                      autoFocus
                                    />
                                    <Button
                                      color="success"
                                      size="sm"
                                      onClick={handleSaveSequenciaTitle}
                                      style={{
                                        padding: '2px 8px',
                                        fontSize: '12px',
                                      }}
                                    >
                                      ✓
                                    </Button>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={handleCancelEditSequencia}
                                      style={{
                                        padding: '2px 8px',
                                        fontSize: '12px',
                                      }}
                                    >
                                      ✕
                                    </Button>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                    }}
                                  >
                                    {tituloSequencia && (
                                      <>
                                        <span style={{ whiteSpace: 'pre' }}>
                                          {' '}
                                          -{' '}
                                        </span>
                                        <span>{tituloSequencia}</span>
                                      </>
                                    )}
                                    <Button
                                      color="link"
                                      size="sm"
                                      onClick={() => {
                                        handleStartEditSequencia(
                                          Number(atividade),
                                          sequencia,
                                          tituloSequencia,
                                        );
                                      }}
                                      style={{
                                        padding: '0 4px',
                                        fontSize: '12px',
                                        color: '#6c757d',
                                      }}
                                      title="Editar título da sequência"
                                    >
                                      ✏️
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </td>
                            <Tooltip title="Somatório das quantidades desta sequência">
                              <td className="text-center">
                                <>{arredondaDecimais(quantidade)}</>
                              </td>
                            </Tooltip>{' '}
                            <Tooltip title="Somatório dos custos unitários desta sequência">
                              <td className="text-center">
                                <>
                                  {formatCurrency(
                                    arredondaDecimais(custoUnitarioSomatorio),
                                  )}
                                </>
                              </td>
                            </Tooltip>{' '}
                            <Tooltip title="Somatório dos custos totais desta sequência">
                              <td className="text-center">
                                <>
                                  {formatCurrency(
                                    arredondaDecimais(custoTotalSomatorio),
                                  )}
                                </>
                              </td>
                            </Tooltip>{' '}
                            <td colSpan={2}> </td>
                            <Tooltip title="Peso total desta sequência">
                              <td className="text-center">
                                <>{arredondaDecimais(pesoTotal)}</>
                              </td>
                            </Tooltip>{' '}
                          </tr>
                        )}

                        {/* Itens da sequencia */}
                        {/* {sequenciaItems.map((item, index) => (
                          <Fragment key={item.id}>
                            {renderLinhaMaterial(item, index)}
                            {renderComposicaoKit(item)}
                          </Fragment>
                        ))} */}
                        {renderItemsKitGrouped(sequenciaItems)}
                      </Fragment>
                    );
                  })}
                </tbody>
              </Fragment>
            );
          })}
        </>
      );
    }

    async function handleCarregarComposicao() {
      // Swal.fire({
      //   icon: 'info',
      //   text: `Buscando composição...`,
      //   allowOutsideClick: false,
      //   showConfirmButton: false,
      // });

      // if (!exibeKit) await carregaOrcamentoKits();

      if (!exibeKit) {
        Swal.fire({
          icon: 'info',
          text: `Buscando composição...`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        await carregaOrcamentoKits(true);
      }

      setExibeKit(!exibeKit);
      // Swal.close();
    }

    const pesoTotal = orcamentoMateriais.reduce((acc, item) => {
      return acc + (item?.material?.peso ?? 0) * item.quantidade;
    }, 0);

    return (
      <MaterialContainer>
        {/* <Row hidden className="-mt-2">
          <Col>
            <span title="Lista de materiais alterada!">
              <Badge color="warning" className="ml-2">
                <span className="alert-icon">
                  <FaExclamationTriangle />
                </span>
                A lista de materiais foi alterada manualmente!
              </Badge>
            </span>
          </Col>
        </Row> */}

        {atividadesComGap.size > 0 && (
          <Row className="ml-2 mb-2">
            <Col xs="11">
              <Alert
                color="warning"
                className="mb-0"
                style={{
                  backgroundColor: '#fff3cd',
                  color: '#856404',
                  borderColor: '#ffeeba',
                }}
              >
                <FaExclamationTriangle className="mr-2" />
                <strong>Atenção:</strong> Existem atividades com sequências
                inconsistentes.
              </Alert>
            </Col>
          </Row>
        )}

        <Row className="ml-1 align-items-center" style={{ marginTop: '-20px' }}>
          <Col xs="2" style={{ paddingLeft: '2rem' }}>
            <h4 className="mb-0">Lista de materiais</h4>
          </Col>
          <Col xs="2" style={{ paddingLeft: '2rem' }}>
            <h4 className="mb-0">Peso total: {arredondaDecimais(pesoTotal)}</h4>
          </Col>

          <Col xs="3" className="d-flex justify-content-end">
            <Button
              size="sm"
              className="btn-icon btn-2 d-flex align-items-center justify-content-center"
              style={{ height: 36, width: '200px', backgroundColor: '#1a8c5b' }}
              color="success"
              type="button"
              onClick={handleExportToSheet}
            >
              <FaFileExcel />
              <span className="btn-inner--text ml-1">Exportar planilha</span>
            </Button>
          </Col>

          <Col xs="1" className="d-flex justify-content-end">
            <Button
              className="btn-icon btn-2 d-flex align-items-center justify-content-center"
              color="primary"
              type="button"
              outline
              size="sm"
              style={{ height: 36, width: '100%' }}
              onClick={handleCarregarComposicao}
            >
              {exibeKit ? 'Esconder Kits' : 'Mostrar Kits'}
            </Button>
          </Col>

          <Col xs="2" className="d-flex justify-content-end">
            <Input
              type="select"
              id="agrupadorSelect"
              value={agrupadorSelecionado}
              onChange={e => {
                setAgrupadorSelecionado(e.target.value);
                setOrcamentoMateriais(prevMateriais =>
                  prevMateriais.map(material => ({
                    ...material,
                    excluirMaterial: false,
                  })),
                );
              }}
              className="form-control"
              style={{ height: 46 }}
            >
              <option value="Grupo">Agrupar por Grupo</option>
              <option value="Atividade">Agrupar por Atividade</option>
            </Input>
          </Col>

          <Col xs="2" className="d-flex justify-content-end">
            <Tooltip
              title={
                <div>
                  <div
                    style={{
                      fontWeight: 'bold',
                      marginBottom: 6,
                      fontSize: '14px',
                    }}
                  >
                    Filtros ativos:
                  </div>

                  <ul
                    style={{ margin: 0, paddingLeft: '1rem', fontSize: '13px' }}
                  >
                    {qntFiltrosUsados.map((item, index) => (
                      <li key={index} style={{ marginBottom: 4 }}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              }
            >
              <div
                className="mr-2 float-right"
                style={{ position: 'relative', display: 'inline-block' }}
              >
                <Button
                  type="button"
                  color="primary"
                  size="sm"
                  style={{ height: 46, width: 46 }}
                  onClick={() => setModalFiltros(prev => !prev)}
                >
                  <FaFilter />
                </Button>

                {qntFiltrosUsados.length > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      background: '#f5365c',
                      color: 'white',
                      borderRadius: '50%',
                      minWidth: 18,
                      height: 18,
                      padding: '0 4px',
                      fontSize: 11,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    {qntFiltrosUsados.length}
                  </span>
                )}
              </div>
            </Tooltip>

            <Button
              type="button"
              color="danger"
              size="sm"
              style={{ height: 46, width: 46 }}
              onClick={() => setLimparFiltros(prev => !prev)}
            >
              <FaEraser />
            </Button>
          </Col>
        </Row>

        <Row className="ml-2">
          <Col>
            <MaterialListContainer>
              <Table responsive style={{ width: '100%' }}>
                {agrupadorSelecionado === 'Grupo'
                  ? renderTabelaPorGrupo()
                  : renderTabelaPorAtividade()}
              </Table>
            </MaterialListContainer>
          </Col>
        </Row>
      </MaterialContainer>
    );
  }

  const sortedUsers = [...usuariosOnline].sort((a, b) => a.id - b.id);

  const visibleUsers = sortedUsers.slice(0, 3);
  const hiddenUsers = sortedUsers.slice(3);

  const hiddenHasNotification = hiddenUsers.some(
    u => userNotifications[u.id]?.hasUnread,
  );

  const hiddenNotificationCount = hiddenUsers.filter(
    u => userNotifications[u.id]?.hasUnread,
  ).length;

  return (
    <>
      <UserSmallHeader />
      <Container className="mt-2" fluid>
        <Row style={{ width: '100%' }}>
          <Col sm="12">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flexWrap: 'wrap',
                alignContent: 'center',
              }}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '13px',
                  fontWeight: 500,
                  height: '26px',
                  lineHeight: '26px',
                }}
              >
                <FaCircle size={8} color="#22c55e" style={{ marginRight: 6 }} />
                {usuariosOnline.length} online
              </span>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {visibleUsers.map(user => {
                  const hasNotification = userNotifications[user.id]?.hasUnread;

                  return (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                    <span
                      key={user.id}
                      onClick={() => openUserModal(user)}
                      className="mt-1 user-badge"
                      style={{
                        background: '#e9f2ff',
                        color: '#1a73e8',
                        padding: '4px 8px',
                        borderRadius: '16px',
                        fontSize: '13px',
                        fontWeight: 500,
                        display: 'inline-flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        maxWidth: '120px',
                      }}
                    >
                      <span
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '100%',
                        }}
                      >
                        {user.nome}
                      </span>

                      {hasNotification && (
                        <span
                          style={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: 'red',
                            borderRadius: '50%',
                            marginLeft: '6px',
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </span>
                  );
                })}

                {hiddenUsers.length > 0 && (
                  <div
                    style={{ position: 'relative' }}
                    className="mt-1"
                    ref={hiddenRef}
                  >
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                    <span
                      onClick={() => setShowHidden(prev => !prev)}
                      style={{
                        cursor: 'pointer',
                        fontWeight: hiddenHasNotification ? 600 : 400,
                        color: hiddenHasNotification ? '#ef4444' : 'inherit',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 4,
                      }}
                    >
                      +{hiddenUsers.length}
                      {hiddenHasNotification && (
                        <span
                          style={{
                            width: 8,
                            height: 8,
                            backgroundColor: 'red',
                            borderRadius: '50%',
                          }}
                        />
                      )}
                    </span>

                    {showHidden && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '120%',
                          left: 0,
                          background: '#fff',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          borderRadius: 8,
                          padding: 8,
                          minWidth: 160,
                          zIndex: 1000,
                        }}
                      >
                        {hiddenUsers.map(u => {
                          const hasNotification =
                            userNotifications[u.id]?.hasUnread;

                          return (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                            <div
                              key={u.id}
                              onClick={() => {
                                openUserModal(u);
                                setShowHidden(false);
                              }}
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '6px 8px',
                                cursor: 'pointer',
                                borderRadius: 6,
                                // background: '#e9f2ff',
                                color: '#1a73e8',
                                // padding: '4px 8px',
                                // borderRadius: '16px',
                                fontSize: '13px',
                                fontWeight: 500,
                                // display: 'inline-flex',
                                // alignItems: 'center',
                                // cursor: 'pointer',
                                maxWidth: '120px',
                              }}
                              // eslint-disable-next-line no-return-assign
                              onMouseEnter={e =>
                                (e.currentTarget.style.background = '#f3f4f6')
                              }
                              // eslint-disable-next-line no-return-assign
                              onMouseLeave={e =>
                                (e.currentTarget.style.background =
                                  'transparent')
                              }
                            >
                              <span>{u.nome}</span>

                              {hasNotification && (
                                <span
                                  style={{
                                    width: 6,
                                    height: 6,
                                    backgroundColor: 'red',
                                    borderRadius: '50%',
                                  }}
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-2" style={{ width: '100%', position: 'relative' }}>
          <Col sm="12">
            <ConfiguracaoDetalhesCabecalho
              orcamentoId={orcamentoId}
              gnf={gnf}
            />
          </Col>
        </Row>
        <Row style={{ width: '100%' }}>
          <Col sm="12">
            <ConfiguracaoMaterialAvulso
              setMateriaisAvulsosPlanilha={setMateriaisAvulsosPlanilha}
              // recarregarLista={recarregarLista}
              setDeveRecarregarComp={setDeveRecarregarComp}
              possuiMateriaisIndpie={possuiMateriaisIndpie}
              orcamentoMateriais={orcamentoMateriais}
              loadingIndpie={loadingIndpie}
              setLoadingIndpie={setLoadingIndpie}
            />
          </Col>
        </Row>
        <Row style={{ width: '100%' }}>
          <Col sm="12">
            <Modal
              isOpen={modalOpen}
              toggle={() => setModalOpen(false)}
              size="xl"
              className="modal-dialog-centered"
            >
              <ModalHeader toggle={() => setModalAdicionarItens(false)}>
                Logs de {selectedUser?.nome}
              </ModalHeader>
              <ModalBody style={{ maxHeight: '60vh' }}>
                <Row className="align-items-center">
                  <div
                    style={{
                      width: '100%',
                      height: '60vh',
                      textAlign: 'center',
                    }}
                  >
                    <AutoSizer>
                      {({ width, height }) => (
                        // <TableVirtualized
                        //   width={width}
                        //   height={height}
                        //   headerHeight={40}
                        //   rowHeight={cache.rowHeight}
                        //   rowCount={logsUsuario.length}
                        //   rowGetter={({ index }) => logsUsuario[index]}
                        //   rowStyle={{
                        //     borderBottom: '1px solid #ccc',
                        //     fontSize: '0.9rem',
                        //   }}
                        // >
                        <TableVirtualized
                          width={width}
                          height={height}
                          headerHeight={40}
                          rowHeight={cache.rowHeight}
                          deferredMeasurementCache={cache}
                          rowCount={logsUsuario.length}
                          rowGetter={({ index }) => logsUsuario[index]}
                          rowStyle={{
                            borderBottom: '1px solid #ccc',
                            fontSize: '0.9rem',
                          }}
                        >
                          <Column
                            label="DATA"
                            dataKey="dataGeracao"
                            width={150}
                            cellRenderer={({ cellData }) => (
                              <div style={{ padding: '8px 0' }}>
                                {String(
                                  new Intl.DateTimeFormat('pt-BR', {
                                    dateStyle: 'short',
                                    timeStyle: 'medium',
                                  }).format(new Date(cellData)),
                                )}
                              </div>
                            )}
                          />
                          <Column
                            label="Descrição"
                            flexGrow={1}
                            dataKey="descricao"
                            width={800}
                            cellRenderer={({ parent, rowIndex, rowData }) => (
                              <CellMeasurer
                                cache={cache}
                                columnIndex={0}
                                rowIndex={rowIndex}
                                parent={parent}
                              >
                                <div
                                  style={{
                                    wordBreak: 'break-word',
                                    whiteSpace: 'normal',
                                    padding: '8px 0',
                                  }}
                                >
                                  {rowData.descricao}
                                </div>
                              </CellMeasurer>
                            )}
                          />
                        </TableVirtualized>
                      )}
                    </AutoSizer>
                  </div>
                </Row>
              </ModalBody>
              <ModalFooter> </ModalFooter>
            </Modal>
          </Col>
          <Col sm="12">
            {kitCarregado && matCarregado && renderMateriais()}
            <div
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                display: 'flex',
                gap: '10px',
                zIndex: 1000,
              }}
            >
              <FloatingButton
                hidden={
                  !orcamentoMateriais?.filter(
                    item =>
                      item.excluirMaterial === true &&
                      orcamentoKits.some(
                        kit =>
                          kit.diteCodigo === item.material.diteCodigo &&
                          kit.composicao?.length > 0,
                      ),
                  ).length
                }
                className="hide-on-print"
                color="primary"
                onClick={handleAdicionarItensKit}
                disabled={
                  orcamentoMateriais?.filter(
                    item => item.excluirMaterial === true,
                  ).length !== 1
                }
                title={
                  orcamentoMateriais?.filter(
                    item => item.excluirMaterial === true,
                  ).length !== 1
                    ? 'Selecione somente um kit'
                    : 'Adicionar itens do Kit'
                }
                style={{
                  position: 'relative',
                  bottom: 'auto',
                  right: 'auto',
                }}
              >
                <FaPlus style={{ color: 'white' }} />
              </FloatingButton>
              <FloatingButton
                hidden={
                  !orcamentoMateriais?.filter(
                    item => item.excluirMaterial === true,
                  ).length
                }
                className="hide-on-print"
                color="secondary"
                onClick={handleDeletePropostaConfiguracaoMaterial}
                style={{ position: 'relative', bottom: 'auto', right: 'auto' }}
              >
                <FaTrash style={{ color: 'white' }} />
              </FloatingButton>
            </div>
          </Col>
        </Row>

        <ModalFiltro
          modalFiltros={modalFiltros}
          setModalFiltros={setModalFiltros}
          // opcoesDescricao={opcoesDescricao}
          // campoBusca={campoBusca}
          // setCampoBusca={setCampoBusca}
          // atividadesUsadas={atividadesUsadas}
          // atividadeSelecionada={atividadeSelecionada}
          // atividadeFiltro={atividadeFiltro}
          orcamentoMateriais={orcamentoMateriais}
          // setAtividadeFiltro={setAtividadeFiltro}
          // sequenciaFiltro={sequenciaFiltro}
          // setSequenciaFiltro={setSequenciaFiltro}
          // handleFiltro={handleFiltro}
          // resetarValores={resetarValores}
          // aplicarFiltros={aplicarFiltros}
          setQntFiltrosUsados={setQntFiltrosUsados}
          limparFiltros={limparFiltros}
          setFiltroOrcamentoMateriais={setFiltroOrcamentoMateriais}
          setHasDadosFiltro={setHasDadosFiltro}
        />

        <Modal
          isOpen={modalAdicionarItens}
          toggle={() => setModalAdicionarItens(false)}
          size="lg"
          className="modal-dialog-centered"
        >
          <ModalHeader toggle={() => setModalAdicionarItens(false)}>
            Salvar Itens do Kit: {kitSelecionado?.material.descricao}
          </ModalHeader>
          <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <Row className="align-items-center">
              <Col sm="7">
                <AutocompleteItem
                  key={resetKey}
                  hideTitle
                  handleSelecionarItem={handleSelecionarItem}
                  // handleSelecionarItemDomsge={handleSelecionarItemDomsge}
                  noAutoFocus
                  emprCodigo={codEmpresa}
                  compact
                  usarDiv
                />
              </Col>
              <Col sm="2">
                <Input
                  type="number"
                  id="quantidade-input"
                  min={1}
                  step={1}
                  value={quantidadeNovoItem}
                  onChange={e =>
                    setQuantidadeNovoItem(parseInt(e.target.value, 10) || 1)
                  }
                />
              </Col>
              <Col sm="3" className="d-flex align-items-end">
                {' '}
                <Button
                  className="btn-icon"
                  color="primary"
                  type="button"
                  onClick={addItemComposicao}
                  disabled={!itemDomsgeSelecionado}
                >
                  <FaPlusCircle /> teste
                </Button>
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-sm table-hover align-middle w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      style={{
                        width: '10%',
                        textAlign: 'center',
                        verticalAlign: 'middle',
                      }}
                    >
                      <Checkbox
                        checked={itensComposicao.every(
                          item => item.selecionado,
                        )}
                        onChange={e => {
                          const allSelected = itensComposicao.every(
                            item => item.selecionado,
                          );
                          setItensComposicao(prev =>
                            prev.map(item => ({
                              ...item,
                              selecionado: !allSelected,
                            })),
                          );
                        }}
                        color="primary"
                      />
                    </th>
                    <th
                      style={{
                        textAlign: 'center',
                        width: '20%',
                        verticalAlign: 'middle',
                      }}
                    >
                      Código
                    </th>
                    <th
                      style={{
                        textAlign: 'center',
                        width: '40%',
                        verticalAlign: 'middle',
                      }}
                    >
                      Descrição
                    </th>
                    <th
                      style={{
                        textAlign: 'center',
                        width: '30%',
                        verticalAlign: 'middle',
                      }}
                    >
                      Quantidade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {itensComposicao.map((item, index) => (
                    <tr
                      key={index}
                      className={`${item.selecionado ? 'table-active' : ''} ${
                        item.id === null ? 'table-secondary' : ''
                      }`}
                      title={
                        item.id === null ? 'Material não existe no portal' : ''
                      }
                    >
                      <td
                        style={{ textAlign: 'center', verticalAlign: 'middle' }}
                      >
                        <Checkbox
                          checked={item.selecionado}
                          onChange={e =>
                            handleSelectionChange(index, e.target.checked)
                          }
                          color="primary"
                          disabled={item.id === null}
                        />
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <span className="font-weight-bold text-primary">
                          {buscaCodigoMaterial(item.id)}
                        </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <span className="text-sm">{item.descricao}</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <Input
                          type="number"
                          value={item.quantidadeEditavel}
                          onChange={e =>
                            handleQuantidadeChange(
                              index,
                              parseFloat(e.target.value) || 0,
                            )
                          }
                          min="1"
                          step="1"
                          disabled={!item.selecionado || item.id === null}
                          className="text-right w-75"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={() => setModalAdicionarItens(false)}
              className="min-width-100"
              outline
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={handleAdicionarItensConfirmar}
              disabled={
                itensComposicao.filter(item => item.selecionado).length === 0
              }
              className="min-width-100"
            >
              Salvar
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

export default ConfiguracaoMateriais;
